import * as types from "./actiontype";
import * as appActions from '../../../actions/appactions';
import secmasterService from '../services/secmasterservice';
import { checkAccess, getUserSession } from '../../../actions/securityactions'
import * as constants from './../constants';
import securityService from "../../../services/securityservice";
import { createSearchParams } from "react-router-dom";
import * as appConstants from './../../../overrides/appconstants';
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import { current } from "@reduxjs/toolkit";


export const checkSecurityModuleAccess = () => {
    return async function (dispatch) {
        let userSession = await dispatch(getUserSession());
        if (!userSession || !userSession.menus)
            return;
        let permissionsToUpdate = {
            /*User Search*/
            hasAddNewUser: securityService.hasMenus(userSession.menus, [703]),
            hasResetUserSearch: securityService.hasMenus(userSession.menus, [704]),
            hasUserSearch: securityService.hasMenus(userSession.menus, [705]),

            /*User Listing*/
            hasViewUser: securityService.hasMenus(userSession.menus, [706]),
            hasActiveDeactiveUser: securityService.hasMenus(userSession.menus, [707]),
            hasUnlockUser: securityService.hasMenus(userSession.menus, [708]),
            hasResetUserPassword: securityService.hasMenus(userSession.menus, [709]),

            /*User Info*/
            hasCopyUser: securityService.hasMenus(userSession.menus, [710]),
            hasSaveUser: securityService.hasMenus(userSession.menus, [711]),
            hasUserApplicableBranch: securityService.hasMenus(userSession.menus, [712]),
            hasUserPartyCode: securityService.hasMenus(userSession.menus, [713]),
            hasResetUser: securityService.hasMenus(userSession.menus, [714]),

            /*User Branch*/
            hasAddUserBranch: securityService.hasMenus(userSession.menus, [715]),
            hasRemoveUserBranch: securityService.hasMenus(userSession.menus, [716]),
            hasResetUserBranch: securityService.hasMenus(userSession.menus, [717]),
            hasSaveUserBranch: securityService.hasMenus(userSession.menus, [718]),

            /*Group Page*/
            hasAddNewGroup: securityService.hasMenus(userSession.menus, [720]),
            hasResetGroupSearch: securityService.hasMenus(userSession.menus, [721]),
            hasSearchGroup: securityService.hasMenus(userSession.menus, [722]),
            hasViewGroup: securityService.hasMenus(userSession.menus, [723]),

            hasResetGroup: securityService.hasMenus(userSession.menus, [724]),
            hasSaveGroup: securityService.hasMenus(userSession.menus, [725]),
            hasGroupMenus: securityService.hasMenus(userSession.menus, [726]),
            hasGroupReports: securityService.hasMenus(userSession.menus, [727]),

            hasResetGroupMenus: securityService.hasMenus(userSession.menus, [728]),
            hasSaveGroupMenus: securityService.hasMenus(userSession.menus, [729]),
            hasResetGroupReports: securityService.hasMenus(userSession.menus, [730]),
            hasSaveGroupReports: securityService.hasMenus(userSession.menus, [731]),

            /*User Group*/
            hasAddUserGroup: securityService.hasMenus(userSession.menus, [733]),
            hasRemoveUserGroup: securityService.hasMenus(userSession.menus, [734]),
            hasResetUserGroup: securityService.hasMenus(userSession.menus, [735]),
            hasSaveUserGroup: securityService.hasMenus(userSession.menus, [736]),

            /*Password Profile*/
            hasResetPasswordProfile: securityService.hasMenus(userSession.menus, [738]),
            hasSavePasswordProfile: securityService.hasMenus(userSession.menus, [739]),
            hasViewPasswordProfile: securityService.hasMenus(userSession.menus, [740]),


        };
        dispatch(updateSecurityModulePermissions(permissionsToUpdate));

    }
}
export const updateSecurityModulePermissions = (payload) => {
    return {
        type: types.UPDATE_SECURITY_MODULE_PERMISSIONS,
        payload
    }
}

export function getInsuredInfoMasters(productType) {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getInsuredInformationMasters(productType);
            if (sr.result) {
                dispatch(getInsuredInformationMastersEnd(sr.result));
            }
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export function getSecurityMasters() {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getSecurityMasters();
            if (sr.result) {
                dispatch(getSecurityMastersEnd(sr.result));
            }
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const getInsuredInformationMastersEnd = (result) => {
    return {
        type: types.GET_INSURED_INFORMATION_MASTERS_END,
        result
    }
}
export const getSecurityMastersEnd = (result) => {
    return {
        type: types.GET_SECURITY_MASTERS_END,
        result
    }
}

export function getUserSearchResults(page, section) {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let searchUserInfo = {
                "UserId": currentState[section].userId == "" ? 0 : currentState[section].userId,
                "UserName": currentState[section].userName == "" ? 0 : currentState[section].userName,
                "ActiveFrom": currentState[section].activeFrom,
                "ActiveTo": currentState[section].activeTo,
                "IsActiveYN": currentState[section].isActiveYN ? "Y" : "N",
                "Page": page,
                "SortString": currentState[section].sortString,
                "PageSize": 10,
            }
            let pagedResult = await secmasterService.getUserSearchResults(searchUserInfo);
            console.log("pagedResult", pagedResult);
            if (!pagedResult) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            if (section == "userSearch") {
                if (pagedResult.result.length == 0) {
                    dispatch(updateUserSearchResult(pagedResult));
                    dispatch(showUserSearchResults())
                    return dispatch(showUserTableSearchResults(false))
                }
                if (pagedResult) {
                    dispatch(updateUserSearchResult(pagedResult));
                    dispatch(showUserSearchResults())
                    return dispatch(showUserTableSearchResults(true))
                    //  setLoading(false);
                }
            }
            else {

                if (pagedResult.result.length == 0) {
                    dispatch(updateAssignUserGroupsSearchResult(pagedResult));
                    dispatch(showAssignUserGroupsSearchResults())
                    return dispatch(showAssignUserGroupsTableSearchResults(false))
                }
                if (pagedResult) {
                    dispatch(updateAssignUserGroupsSearchResult(pagedResult));
                    dispatch(showAssignUserGroupsSearchResults())
                    return dispatch(showAssignUserGroupsTableSearchResults(true))
                    //  setLoading(false);
                }
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const updateUserSearchResult = (pagedResult) => {
    return {
        type: types.UPDATE_USER_SEARCH_RESULT,
        pagedResult
    }
}
export const showUserSearchResults = () => {
    return {
        type: types.SHOW_USER_SEARCH_RESULTS
    }
}
export const showUserTableSearchResults = (data) => {
    return {
        type: types.SHOW_USER_TABLE_SEARCH_RESULTS,
        payload: data
    }
}


export const savePasswordProfile = () => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            var passProfileId = currentState.passwordProfile.passwordProfileId;
            let savePasswordProfileInfo = {

                "ProfileName": currentState.passwordProfile.profileName,
                "PasswordProfileId": passProfileId == null || passProfileId == '' ? 0 : passProfileId,
                "SpecialCharNotAllowed": currentState.passwordProfile.specialCharNotAllowed,
                "MinimumLength": currentState.passwordProfile.minimumLength,
                "MaximumLength": currentState.passwordProfile.maximumLength,
                "PasswordAge": currentState.passwordProfile.passwordAgeInDays,
                "RemainderDaysBeforeExpiry": currentState.passwordProfile.remainderDaysBeforeExp,
                "PasswordHistory": currentState.passwordProfile.passwordHistory,
                "LoginFailCount": currentState.passwordProfile.loginFailCount,
                "MatchCharCount": currentState.passwordProfile.matchCharCount,
                "ResetPasswordYn": currentState.passwordProfile.passwordResetYN == null ? "N" : "Y",
                "SplCharMandatoryYn": currentState.passwordProfile.splCharMandatoryYN == null ? "N" : "Y",
                "OneUpperCaseYn": currentState.passwordProfile.atLeastOneUpperCase == null ? "N" : "Y",
                "OneLowerCaseYn": currentState.passwordProfile.atLeastOneLowerCase == null ? "N" : "Y",
                "OneNumberYn": currentState.passwordProfile.atLeastOneNumber == null ? "N" : "Y",
                "MatchCharSamePositionYn": currentState.passwordProfile.matchCharAtSamePosition == null ? "N" : "Y",
                "MatchCharAtAnyPostYn": currentState.passwordProfile.matchCharAtAnyPosition == null ? "N" : "Y",
                "ResetFailCount": currentState.passwordProfile.resetFailCountOnLogin == null ? "N" : "Y",
                "DailyResetFailCount": currentState.passwordProfile.resetFailCountDaily == null ? "N" : "Y",
                "CaptchaYn": currentState.passwordProfile.captchaRequired == null ? "N" : "Y",
                "LogonBannerYn": currentState.passwordProfile.logonBannerYN == null ? "N" : "Y",

            }
            let sr = await secmasterService.savePasswordProfile(savePasswordProfileInfo);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(appActions.showMessage("Successfully Saved Profile!", { buttons: ['Ok'] }));
           await  dispatch(getAllPasswordProfiles(1));
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };

};

export function getAllPasswordProfiles(page) {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let search = {
                "Page": page,
                "PageSize": 10,
                "SortString": currentState.passwordProfileListing.sortString
            }
            let pagedResult = await secmasterService.getAllPasswordProfiles(search);
            console.log("pagedResult", pagedResult);
            if (pagedResult.hasErrors) {
                dispatch(appActions.showValidationErrors());
                return false;
            }


            if (pagedResult.result.length == 0) {
                dispatch(getPasswordProfilesEnd(pagedResult))
                //dispatch(showUserSearchResults())
                return dispatch(showPasswordListingTableSearchResults(false))
            }
            if (pagedResult) {
                dispatch(getPasswordProfilesEnd(pagedResult))
                //dispatch(showUserSearchResults())
                return dispatch(showPasswordListingTableSearchResults(true))
                //  setLoading(false);
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export const getPasswordProfilesEnd = (result) => {
    return {
        type: types.GET_ALL_PASSWORD_PROFILE_PROFILE_END,
        payload: result
    }
}

export function getAllPasswordProfilesByProfileId(passwordProfileId) {
    return async function (dispatch, state) {
        let currentState = getState(state());
        // passwordProfileId=2 ;
        let params = {
            "passwordProfileId": passwordProfileId
        }
        console.log(passwordProfileId);
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getAllPasswordProfilesByProfileId(params);
            console.log("pagedResult", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            dispatch(getPasswordProfilesByProfileIdEnd(sr))
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export const getPasswordProfilesByProfileIdEnd = (result) => {
    return {
        type: types.GET_ALL_PASSWORD_PROFILE_BY_PROFILE_ID_END,
        payload: result
    }
}



/*export const updatePasswordProfile = () => {
  return async function (dispatch, state) {
    let currentState = getState(state());
  let savedPasswordProfileInfo = {
 
    "ProfileName": currentState.passwordProfile.profileName,
        //"PasswordProfileId": currentState.passwordProfile.passwordProfileId,
        "SpecialCharNotAllowed": currentState.passwordProfile.specialCharNotAllowed,
        "MinimumLength": currentState.passwordProfile.minimumLength,
        "MaximumLength": currentState.passwordProfile.maximumLength,
        "PasswordAge": currentState.passwordProfile.passwordAgeInDays,
        "RemainderDaysBeforeExpiry": currentState.passwordProfile.remainderDaysBeforeExp,
        "PasswordHistory": currentState.passwordProfile.passwordHistory,
        "LoginFailCount": currentState.passwordProfile.loginFailCount,
        "MatchCharCount": currentState.passwordProfile.matchCharCount,
        "ResetPasswordYn": currentState.passwordProfile.passwordResetYN == null ? "N" : "Y",
        "SplCharMandatoryYn": currentState.passwordProfile.splCharMandatoryYN == null ? "N" : "Y",
        "OneUpperCaseYn": currentState.passwordProfile.atLeastOneUpperCase == null ? "N" : "Y",
        "OneLowerCaseYn": currentState.passwordProfile.atLeastOneLowerCase == null ? "N" : "Y",
        "OneNumberYn": currentState.passwordProfile.atLeastOneNumber == null ? "N" : "Y",
        "MatchCharSamePositionYn": currentState.passwordProfile.matchCharAtSamePosition == null ? "N" :"Y",
        "MatchCharAtAnyPostYn": currentState.passwordProfile.matchCharAtAnyPosition == null ? "N" : "Y",
        "ResetFailCount": currentState.passwordProfile.resetFailCountOnLogin == null ? "N" : "Y",
        "DailyResetFailCount": currentState.passwordProfile.resetFailCountDaily == null ? "N" : "Y",
        "CaptchaYn": currentState.passwordProfile.captchaRequired == null ? "N" : "Y",
        "LogonBannerYn": currentState.passwordProfile.logonBannerYN == null ? "N" : "Y",
        
  }
alert('i am here')
  let sr = await secmasterService.updatePasswordProfile(savedPasswordProfileInfo);
      console.log("srrr", sr);
      if (sr.hasErrors) {
        dispatch(appActions.showValidationErrors(sr));
        return false;
      }
    };
 
};*/

export function getAllMenus() {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getAllMenus();
            console.log("pagedResult", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            dispatch(getAllMenusEnd(sr))
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export const getAllMenusEnd = (result) => {
    return {
        type: types.GET_ALL_MENUS_END,
        payload: result
    }
}

export function getAllGroups(page) {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getAllGroups();
            console.log("pagedResult", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            dispatch(getAllGroupsEnd(sr))
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export const getAllGroupsEnd = (result) => {
    return {
        type: types.GET_ALL_GROUPS_END,
        payload: result
    }
}

export function getAllGroupMenus(page) {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getAllGroupMenus();
            console.log("pagedResult", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            dispatch(getAllGroupMenusEnd(sr))
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export const getAllGroupMenusEnd = (result) => {
    return {
        type: types.GET_ALL_GROUP_MENUS_END,
        payload: result
    }
}

export function getAllModules(page) {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getAllModules();
            console.log("pagedResult", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            dispatch(getAllModulesEnd(sr))
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export const getAllModulesEnd = (result) => {
    return {
        type: types.GET_ALL_MODULES_END,
        payload: result
    }
}

export function getAllUserBranches(page) {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getAllUserBranches();
            console.log("pagedResult", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            dispatch(getAllUserBranchesEnd(sr))
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export const getAllUserBranchesEnd = (result) => {
    return {
        type: types.GET_ALL_USER_BRANCHES_END,
        payload: result
    }
}

export const updatePasswordProfileProfile = ({ name, value }) => {
    return {
        type: types.UPDATE_PASSWORD_PROFILE_PROFILE,
        payload: { name, value }
    }
}

export const clearPasswordProfileParams = () => {
    return {
        type: types.CLEAR_PASSWORD_PROFILE_PARAMS
    }
}

export const clearGroupMenuParams = () => {
    return {
        type: types.CLEAR_GROUP_MENU_PARAMS
    }
}

export const getUserSortResults = (status) => {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            await dispatch(updateUserSortString(status));
            await dispatch(getUserSearchResults(1, "userSearch"));
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
};
export const updateUserSortString = (status) => {

    return {
        type: types.UPDATE_USER_SORT_PARAMETER,
        payload: { status }
    }
}
export const showUserMaster = (data) => {
    return {
        type: types.SHOW_USER_MASTER,
        payload: { data }
    }
}
export const updateCurrentUserId = (userId) => {
    return {
        type: types.UPDATE_CURRENT_USER_ID,
        payload: { userId }
    }
}
export const showCurrentUserMaster = (data) => {
    return {
        type: types.SHOW_CURRENT_USER_MASTER,
        payload: data
    }
}
export const getUserMaster = (userId) => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        console.log(userId);
        try {
            dispatch(appActions.setLoading(true));
            let resp = await secmasterService.getUserMaster(userId);
            if (resp.hasErrors) {
                dispatch(appActions.showValidationErrors(resp));
                return false;
            }

            console.log("resp", resp);
            if (resp.result != null) {
                await dispatch(getUserMasterEnd(resp.result));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}
export const getUserMasterEnd = (data) => {
    return {
        type: types.GET_USER_MASTER_END,
        payload: data
    }
}
export const collapseUserSearchResults = (data) => {
    return {
        type: types.COLLAPSE_USER_SEARCH_RESULT,
        payload: data
    }
}
export const collapseUserSearch = (data) => {
    return {
        type: types.COLLAPSE_USER_SEARCH,
        payload: data
    }
}
export const clearUserSearchParams = () => {
    return {
        type: types.CLEAR_USER_SEARCH_PARAMS
    }
}

export const updateUserSearchParams = ({ name, value }) => {
    return {
        type: types.UPDATE_USER_SEARCH_PARAMS,
        payload: { name, value }
    }
}
export const updateUserSearchCheckboxParams = ({ name, checked }) => {
    return {
        type: types.UPDATE_USER_SEARCH_CHECKBOX_PARAMS,
        payload: { name, checked }
    }
}

export const clearUserMasterInformation = () => {
    return {
        type: types.CLEAR_USER_MASTER_INFORMATION
    }
}
export const updateUserMasterParams = ({ name, value }) => {
    return {
        type: types.UPDATE_USER_MASTER_PARAMS,
        payload: { name, value }
    }
}
export const updateUserMasterCheckboxParams = ({ name, checked }) => {
    return {
        type: types.UPDATE_USER_MASTER_CHECKBOX_PARAMS,
        payload: { name, checked }
    }
}
export const saveUserMasterInfo = () => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            if ((currentState.userMaster.userType == constants.USER_TYPE_AGENT || currentState.userMaster.userType == constants.USER_TYPE_BROKER) &&
                (currentState.userMaster.premiumAccount == null || currentState.userMaster.premiumAccount == "" || currentState.userMaster.commissionAccount == null || currentState.userMaster.commissionAccount == "")) {
                let confirm = await dispatch(appActions.showMessage(
                    "Please enter Premium/Commission Account in Party Code Tab", { buttons: ['Close'] }));
                if (confirm === 'Close') {
                    return false;
                }
            }
            dispatch(appActions.setLoading(true));

            let saveUserMaster = {
                "UserId": currentState.userMaster.userId,
                "UserName": currentState.userMaster.userName,
                "Password": currentState.userMaster.password,
                "ReTypePassword": currentState.userMaster.retypePassword,
                "EmployeeId": currentState.userMaster.employeeId,
                "Designation": currentState.userMaster.designation,
                "OfficePhone": currentState.userMaster.officePhone,
                "Extension": currentState.userMaster.extension,
                "ResPhone": currentState.userMaster.resPhone,
                "MobileNo": currentState.userMaster.mobileNo,
                "Fax": currentState.userMaster.fax,
                "Email": currentState.userMaster.email,
                "DefaultCompany": currentState.userMaster.defaultCompany,
                "DefaultPrinterCode": currentState.userMaster.defaultPrinterCode,
                "MacAddress": currentState.userMaster.macAddress,
                "PartyCode": currentState.userMaster.partyCode,
                "UserGroup": currentState.userMaster.userGroup.map(u => u.groupId),
                "PasswordProfile": currentState.userMaster.passwordProfile,
                "StartMenu": currentState.userMaster.startMenu,
                "MangerId": currentState.userMaster.managerId,
                "DefaultDivision": currentState.userMaster.defaultDivision,
                "DefaultDepartment": currentState.userMaster.defaultDepartment,
                "UserType": currentState.userMaster.userType,
                "ShiftCode": currentState.userMaster.shiftCode,
                "MultiMachineLogInYN": currentState.userMaster.multiMachineLoginYN,
                "ForcedPasswordYN": currentState.userMaster.forcedPasswordYN,
                "PasswordExpiryYN": currentState.userMaster.passwordExpiryYN,
                "LockYN": currentState.userMaster.lockYN,
                "UserActiveYN": currentState.userMaster.userActiveYN,
                "ExpiryDate": currentState.userMaster.expiryDate,
                "SignatureFile": currentState.userMaster.signatureFile,
                "PremiumAccount": currentState.userMaster.premiumAccount,
                "CommissionAccount": currentState.userMaster.commissionAccount,
            }

            let sr = await secmasterService.saveUserMasterInfo(saveUserMaster);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            // alert("Successfully Saved!");
            //dispatch(appActions.showTopMessage("Successfully Saved Quotation Information?", { timeout: 2000, messageType: "success" }));
            dispatch(appActions.showMessage("Successfully Saved User!", { buttons: ['Ok'] }));
            //console.log("Successfully Saved!", sr);

            dispatch(getUserSearchResults(currentState?.userSearch?.searchResult?.currentPage ?? 1, "userSearch"));
            dispatch(updateCurrentUserId(sr.result.usR_ID));
            dispatch(showCurrentUserMaster(true));
            dispatch(showUserMaster(true));
            await dispatch(getUserMaster(sr.result.usR_ID));

            return sr.result.usR_NAME
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
};

export const collapseUserGroupSearchResults = (data) => {
    return {
        type: types.COLLAPSE_USER_GROUP_SEARCH_RESULT,
        payload: data
    }
}
export const handleApplicableBranchesRadioBtnChange = (brCode, value) => {
    return {
        type: types.HANDLE_APPLICABLE_BRANCHES_RADIO_BTN_CHANGE,
        payload: { brCode, value },
    }
}
export const handleUserBranchesRadioBtnChange = (brCode, value) => {
    return {
        type: types.HANDLE_USER_BRANCHES_RADIO_BTN_CHANGE,
        payload: { brCode, value },
    }
}

export const resetApplicableBranches = () => {
    return {
        type: types.RESET_APPLICABLE_BRANCHES
    }
}
export const moveToUserBranches = () => {
    return {
        type: types.MOVE_TO_USER_BRANCHES
    }
}
export const removeFromUserBranches = () => {
    return {
        type: types.REMOVE_FROM_USER_BRANCHES
    }
}
export const saveUserApplicableBranches = () => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            let sr;
            dispatch(appActions.setLoading(true));
            if (currentState?.applicableBranches?.userBranches.length == 0 || (currentState?.applicableBranches?.userBranches.length == 1 && currentState?.applicableBranches?.userBranches[0].brCode == 0)) {
                dispatch(appActions.showMessage("No Branches Assigned!", { buttons: ['Close'] }));
                return false;
            }
            let saveUserBranches = {
                "UserId": currentState.userMaster.userId,
                "UserBranches": currentState.applicableBranches.userBranches/* ?.filter(p => p?.brCode != 0) */
            };
            if (currentState.userMaster.userType == constants.USER_TYPE_BROKER) {
                sr = await secmasterService.saveBrokerApplicableBranches(saveUserBranches);
            }
            else {
                sr = await secmasterService.saveUserApplicableBranches(saveUserBranches);
            }
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(appActions.showMessage("Successfully Saved User Branches!", { buttons: ['Ok'] }));

        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}
export const getUserApplicableBranches = () => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let resp = await secmasterService.getUserApplicableBranches(currentState.userMaster.userId);
            if (resp.hasErrors) {
                dispatch(appActions.showValidationErrors(resp));
                return false;
            }

            console.log("resp", resp);
            if (resp.result != null) {
                await dispatch(getUserApplicableBranchesEnd(resp.result));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}
export const getUserApplicableBranchesEnd = (result) => {
    return {
        type: types.GET_USER_APPLICABLE_RBANCHES_END,
        payload: { result }
    }
}

//User Group Page
export const clearUserGroupSearchParams = () => {
    return {
        type: types.CLEAR_USER_GROUP_SEARCH_PARAMS
    }
}
export const collapseUserGroupSearch = (data) => {
    return {
        type: types.COLLAPSE_USER_GROUP_SEARCH,
        payload: data
    }
}

export const updateUserGroupSearchParams = ({ name, value }) => {
    return {
        type: types.UPDATE_USER_GROUP_SEARCH_PARAMS,
        payload: { name, value }
    }
}
export function getUserGroupSearchResults(page) {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let searchGroupSearch = {
                "UserGroupCode": currentState.userGroupSearch.userGroupCode,
                "UserGroupName": currentState.userGroupSearch.userGroupName,
                "Department": currentState.userGroupSearch.department,
                "Page": page,
                "SortString": currentState.userGroupSearch.sortString,
                "PageSize": 10,
            }
            let pagedResult = await secmasterService.getUserGroupSearchResults(searchGroupSearch);
            console.log("pagedResult", pagedResult);
            if (!pagedResult) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            if (pagedResult.result.length == 0) {
                dispatch(updateUserGroupSearchResults(pagedResult));
                dispatch(showUserGroupSearchResults())
                return dispatch(showUserGroupTableSearchResults(false))
            }
            if (pagedResult) {
                dispatch(updateUserGroupSearchResults(pagedResult));
                dispatch(showUserGroupSearchResults())
                return dispatch(showUserGroupTableSearchResults(true))
                //  setLoading(false);
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export const updateUserGroupSearchResults = (pagedResult) => {
    return {
        type: types.UPDATE_USER_GROUP_SEARCH_RESULT,
        pagedResult
    }
}
export const showUserGroupSearchResults = () => {
    return {
        type: types.SHOW_USER_GROUP_SEARCH_RESULTS
    }
}
export const showUserGroupTableSearchResults = (data) => {
    return {
        type: types.SHOW_USER_GROUP_TABLE_SEARCH_RESULTS,
        payload: data
    }
}

export const getUserGroupSortResults = (status) => {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            await dispatch(updateUserGroupSortString(status));
            await dispatch(getUserGroupSearchResults(1));
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
};


export const showUserGroup = (data) => {
    return {
        type: types.SHOW_USER_GROUP,
        payload: { data }
    }
}
export const showCurrentUserGroup = (data) => {
    return {
        type: types.SHOW_CURRENT_USER_GROUP,
        payload: data
    }
}
export const updateCurrentGroupId = (groupId) => {
    return {
        type: types.UPDATE_CURRENT_GROUP_ID,
        payload: { groupId }
    }
}

export const getGroupInfo = (groupId) => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        console.log(groupId);
        try {
            dispatch(appActions.setLoading(true));
            let resp = await secmasterService.getGroupInfo(groupId);
            if (resp.hasErrors) {
                dispatch(appActions.showValidationErrors(resp));
                return false;
            }

            console.log("resp", resp);
            if (resp.result != null) {
                await dispatch(getGroupInfoEnd(resp.result));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}

export const getGroupInfoEnd = (data) => {
    return {
        type: types.GET_GROUP_INFO_END,
        payload: data
    }
}
export const clearUserGroupInformation = () => {
    return {
        type: types.CLEAR_USER_GROUP_INFORMATION
    }
}
export const updateUserGroupCreationParams = ({ name, value }) => {
    return {
        type: types.UPDATE_USER_GROUP_CREATION_PARAMS,
        payload: { name, value }
    }
}
export const saveUserGroupInfo = () => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));

            let saveUserMaster = {
                "GroupId": currentState.userGroupCreate.groupId,
                "UserGroupCode": currentState.userGroupCreate.userGroupCode,
                "UserGroupName": currentState.userGroupCreate.userGroupName,
                "Remarks": currentState.userGroupCreate.remarks,
                "Department": currentState.userGroupCreate.department
            }

            let sr = await secmasterService.saveUserGroupInfo(saveUserMaster);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            // alert("Successfully Saved!");
            //dispatch(appActions.showTopMessage("Successfully Saved Quotation Information?", { timeout: 2000, messageType: "success" }));
            dispatch(appActions.showMessage("Successfully Saved Group!", { buttons: ['Ok'] }));
            //console.log("Successfully Saved!", sr);

            dispatch(getUserGroupSearchResults(1));
            dispatch(updateCurrentGroupId(sr.result.grouP_ID));
            dispatch(showCurrentUserGroup(true));
            dispatch(showUserGroup(true));
            await dispatch(getGroupInfo(sr.result.grouP_ID));

            return sr.result.grouP_NAME
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
};


export function getSystemMenus() {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getSystemMenus(currentState.userGroupCreate.groupId);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            dispatch(getSystemMenusEnd(sr.result))
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const getSystemMenusEnd = (result) => {

    return {
        type: types.GET_SYSTEM_MENUS_END,
        payload: { result }
    }
}

export const resetAssignGroupMenus = () => {
    return {
        type: types.RESET_ASSIGN_GROUP_MENUS
    }
}

export const handleSystemMenuRadioBtnChange/* End */ = (menuId, value) => {
    return {
        type: types.HANDLE_SYSTEM_MENU_RADIO_BTN_CHANGE_END,
        payload: { menuId, value },
    }
}
export const handleSystemMenuRadioBtnChangeForSubChild/* End */ = (menuId, value) => {
    return {
        type: types.HANDLE_SYSTEM_MENU_RADIO_BTN_CHANGE_FOR_SUBCHILD_END,
        payload: { menuId, value },
    }
}
export const toggleMenuOpen/* End */ = (menuId) => {
    return {
        type: types.TOGGLE_MENU_OPEN,
        payload: { menuId },
    }
}
//User Group Page End
export const updateModalsStateParams = ({ name, value }) => {
    return {
        type: types.UPDATE_MODAL_STATE_PARAMS,
        payload: { name, value }
    }
}
export const updateUserGroupSortString = (status) => {

    return {
        type: types.UPDATE_USER_GROUP_SORT_PARAMETER,
        payload: { status }
    }
}

//Password Profile

export const showPasswordListingTableSearchResults = (data) => {
    return {
        type: types.SHOW_PASSWORD_LISTING_TABLE_SEARCH_RESULTS,
        payload: data
    }
}

//Assign User Groups
export const clearAssignUserGroupSearch = () => {
    return {
        type: types.CLEAR_ASSIGN_USER_GROUP_SEARCH
    }
}

export const updateAssignUserGroupSearchParams = ({ name, value }) => {
    return {
        type: types.UPDATE_ASSIGN_USER_GROUP_SEARCH_PARAMS,
        payload: { name, value }
    }
}

export const updateAssignUserGroupsSearchResult = (pagedResult) => {
    return {
        type: types.UPDATE_ASSIGN_USER_GROUP_SEARCH_RESULT,
        pagedResult
    }
}
export const showAssignUserGroupsSearchResults = () => {
    return {
        type: types.SHOW_ASSIGN_USER_GROUP_SEARCH_RESULTS
    }
}
export const showAssignUserGroupsTableSearchResults = (data) => {
    return {
        type: types.SHOW_ASSIGN_USER_GROUP_TABLE_SEARCH_RESULTS,
        payload: data
    }
}

export const getUserGroups = (userId) => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let resp = await secmasterService.getUserGroups(userId);
            if (resp.hasErrors) {
                dispatch(appActions.showValidationErrors(resp));
                return false;
            }

            console.log("resp", resp);
            if (resp.result != null) {
                await dispatch(getUserGroupsEnd(resp.result, userId));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}
export const getUserGroupsEnd = (result, userId) => {
    return {
        type: types.GET_USER_GROUPS_END,
        payload: { result, userId }
    }
}

export const handleAllGroupsRadioBtnChange = (groupId, value) => {
    return {
        type: types.HANDLE_ALL_GROUPS_RADIO_BTN_CHANGE,
        payload: { groupId, value },
    }
}
export const handleUserGroupsRadioBtnChange = (groupId, value) => {
    return {
        type: types.HANDLE_USER_GROUPS_RADIO_BTN_CHANGE,
        payload: { groupId, value },
    }
}

export const resetUserGroups = () => {
    return {
        type: types.RESET_USER_GROUPS
    }
}
export const moveToUserGroups = () => {
    return {
        type: types.MOVE_TO_USER_GROUPS
    }
}
export const removeFromUserGroups = () => {
    return {
        type: types.REMOVE_FROM_USER_GROUPS
    }
}
export const saveUserGroups = () => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let saveUserBranches = {
                "UserId": currentState.userGroups.userId,
                "UserGroups": currentState.userGroups.userGroups
            };

            let sr = await secmasterService.saveUserGroups(saveUserBranches);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(appActions.showMessage("Successfully Saved User Groups!", { buttons: ['Ok'] }));

        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}


export const updateUserActiveStatus = (userId, isActive) => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {

            let confirm = await dispatch(appActions.showMessage(isActive ?
                " Are you sure you want to de-activate this user?"
                : "Are you sure you want to activate this user?", { buttons: ['Yes', 'Close'] }));
            if (confirm === 'Close') {
                return false;
            }
            dispatch(appActions.setLoading(true));

            let sr = await secmasterService.updateUserActiveStatus(userId);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            var displayMessage = isActive ? "de-activated !" : "activated !";
            dispatch(appActions.showMessage("User successfully " + displayMessage, { buttons: ['Ok'] }));
            await dispatch(getUserSearchResults(currentState?.userSearch?.searchResult?.currentPage ?? 1, "userSearch"));

        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}
export const unlockUser = (userId) => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {

            let confirm = await dispatch(appActions.showMessage("Are you sure you want to unlock this user?", { buttons: ['Yes', 'Close'] }));
            if (confirm === 'Close') {
                return false;
            }
            dispatch(appActions.setLoading(true));

            let sr = await secmasterService.unlockUser(userId);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(appActions.showMessage("User Successfully unlocked ", { buttons: ['Ok'] }));
            await dispatch(getUserSearchResults(currentState?.userSearch?.searchResult?.currentPage ?? 1, "userSearch"));

        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}
export const sendForgotPassword = (email,userName) => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {

            let confirm = await dispatch(appActions.showMessage("Are you sure you want to reset password for this user?", { buttons: ['Yes', 'Close'] }));
            if (confirm === 'Close') {
                return false;
            }
            dispatch(appActions.setLoading(true));

            let sr = await secmasterService.sendForgotPassword(email,userName);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(appActions.showMessage("Reset Password Email has been sent to " + email, { buttons: ['Ok'] }));

        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}
export const saveAssignGroupMenus = () => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let saveAssignGroupMenus = {
                "GroupId": currentState.userGroupCreate.groupId,
                "GroupMenus": currentState.assignGroupMenus.systemMenus
            };

            let sr = await secmasterService.saveAssignGroupMenus(saveAssignGroupMenus);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(appActions.showMessage("Successfully Saved Group Menus!", { buttons: ['Ok'] }));

        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}


export function getSystemReports() {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let sr = await secmasterService.getSystemReports(currentState.userGroupCreate.groupId);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors());
                return false;
            }
            dispatch(getSystemReportsEnd(sr.result))
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const getSystemReportsEnd = (result) => {

    return {
        type: types.GET_SYSTEM_REPORT_END,
        payload: { result }
    }
}

export const resetAssignGroupReports = () => {
    return {
        type: types.RESET_ASSIGN_GROUP_REPORTS
    }
}

export const handleSystemReportRadioBtnChange/* End */ = (reportId, value) => {
    return {
        type: types.HANDLE_SYSTEM_REPORT_RADIO_BTN_CHANGE_END,
        payload: { reportId, value },
    }
}


export const saveAssignGroupReports = () => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));
            let saveAssignGroupReports = {
                "GroupId": currentState.userGroupCreate.groupId,
                "GroupReports": currentState.assignGroupReports.systemReports
            };

            let sr = await secmasterService.saveAssignGroupReports(saveAssignGroupReports);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(appActions.showMessage("Successfully Saved Group Reports!", { buttons: ['Ok'] }));

        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}

export const copyUser = () => {
    return async function (dispatch, state) {
        let currentState = getState(state());
        try {
            dispatch(appActions.setLoading(true));

            let saveUserMaster = {
                "UserId": currentState.userMaster.userId,
                "UserName": currentState.userMaster.userName,
                "Password": currentState.userMaster.password,
                "ReTypePassword": currentState.userMaster.retypePassword,
                "EmployeeId": currentState.userMaster.employeeId,
                "Designation": currentState.userMaster.designation,
                "OfficePhone": currentState.userMaster.officePhone,
                "Extension": currentState.userMaster.extension,
                "ResPhone": currentState.userMaster.resPhone,
                "MobileNo": currentState.userMaster.MobileNo,
                "Fax": currentState.userMaster.fax,
                "Email": currentState.userMaster.email,
                "DefaultCompany": currentState.userMaster.defaultCompany,
                "DefaultPrinterCode": currentState.userMaster.defaultPrinterCode,
                "MacAddress": currentState.userMaster.macAddress,
                "PartyCode": currentState.userMaster.partyCode,
                "UserGroup": currentState.userMaster.userGroup.map(u => u.groupId),
                "PasswordProfile": currentState.userMaster.passwordProfile,
                "StartMenu": currentState.userMaster.startMenu,
                "MangerId": currentState.userMaster.managerId,
                "DefaultDivision": currentState.userMaster.defaultDivision,
                "DefaultDepartment": currentState.userMaster.defaultDepartment,
                "UserType": currentState.userMaster.userType,
                "ShiftCode": currentState.userMaster.shiftCode,
                "MultiMachineLogInYN": currentState.userMaster.multiMachineLogInYN,
                "ForcedPasswordYN": currentState.userMaster.forcedPasswordYN,
                "PasswordExpiryYN": currentState.userMaster.passwordExpiryYN,
                "LockYN": currentState.userMaster.lockYN,
                "UserActiveYN": currentState.userMaster.userActiveYN,
                "ExpiryDate": currentState.userMaster.expiryDate,
                "SignatureFile": currentState.userMaster.signatureFile,
            }

            let sr = await secmasterService.copyUser(saveUserMaster);
            console.log("srrr", sr);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            // alert("Successfully Saved!");
            //dispatch(appActions.showTopMessage("Successfully Saved Quotation Information?", { timeout: 2000, messageType: "success" }));
            dispatch(appActions.showMessage("Successfully Copied User to " + sr.result.usR_NAME + " !", { buttons: ['Ok'] }));
            //console.log("Successfully Saved!", sr);

            dispatch(getUserSearchResults(currentState?.userSearch?.searchResult?.currentPage ?? 1, "userSearch"));
            dispatch(updateCurrentUserId(sr.result.usR_ID));
            dispatch(showCurrentUserMaster(true));
            dispatch(showUserMaster(true));
            await dispatch(getUserMaster(sr.result.usR_ID));

            return sr.result.usR_NAME
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
};
const getState = (state) => {
    return state.secmasterReducer;
};